<template>
    <b-collapse 
        :open="false"
        class="collpase-accesibilidad is-hidden-mobile has-text-right"
        position="is-bottom"
        aria-id="menu_accesibilidad_dropup">
        <template #trigger="props">
            <div class="borde-menu-accesibilidad"></div>
            <div class="container">
                <a class="btn-menu-accesibilidad" role="button" aria-controls="menu_accesibilidad_dropup" title="Abrir o cerrar el menú desplegable de accesibilidad">
                    <span class="icono">
                        <i class="las la-universal-access" aria-hidden="true"></i>
                    </span>
                    Menú de accesibilidad
                    <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'" aria-hidden="true"></b-icon>
                </a>
            </div>
        </template>

        <div class="container">
            <b-navbar class="menu-accesibilidad">
                <template #brand>
                    <b-navbar-item>
                        <img src="/images/landing-sucursal-virtual/logo-accesibilidad.svg" alt="Logotipo de Accesibilidad" />
                    </b-navbar-item>
                </template>
                <template #end>
                    <b-navbar-item id="font-up" class="link btn-icon" title="Aumentar el tamaño del texto" @click="fontUp()">
                        <span class="icon">
                            <i class="las la-plus" aria-hidden="true"></i>
                        </span>
                        <span class="text">Aumentar texto</span>
                    </b-navbar-item>
                    <b-navbar-item id="font-down" class="link btn-icon" title="Disminuir el tamaño del texto" @click="fontDown()">
                        <span class="icon">
                            <i class="las la-minus" aria-hidden="true"></i>
                        </span>
                        <span class="text">Disminuir texto</span>
                    </b-navbar-item>
                    <b-navbar-item class="link btn-icon" title="Cambiar la pantalla a modo de alto contraste" @click="grayscale()">
                        <span class="icon">
                            <i class="las la-adjust" aria-hidden="true"></i>
                        </span>
                        <span class="text">Alto contraste</span>
                    </b-navbar-item>
                    <b-navbar-item class="link btn-icon" title="Restablecer los cambios realizados por el menú de accesibilidad" @click="reset()">
                        <span class="icon">
                            <i class="las la-redo-alt" aria-hidden="true"></i>
                        </span>
                        <span class="text">Restablecer</span>
                    </b-navbar-item>
                    <b-navbar-item class="link btn-icon" title="Cerrar el menú desplegable de accesibilidad" @click="close()">
                        <span class="icon">
                            <i class="las la-times" aria-hidden="true"></i>
                        </span>
                        <span class="text">Cerrar</span>
                    </b-navbar-item>
                </template>
            </b-navbar>
        </div>
    </b-collapse>
</template>

<script>

export default {
    
    data() {
        return{
            fontsize:0,
            cont:0
            }
    },
    methods: { 
        getFontSize(){
            this.fontsize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--font-size'));
        },

        fontUp(){
            this.getFontSize();
            if(this.cont <= 5){
                this.fontsize = this.fontsize * 1.1;
                document.documentElement.style.setProperty('--font-size', this.fontsize);
                this.cont ++;
            }
            
        },

        fontDown(){
            this.getFontSize();
            if(this.cont >= -2){
                this.fontsize = this.fontsize * 0.9;
                document.documentElement.style.setProperty('--font-size', this.fontsize);
                this.cont --;
            }
        },

        grayscale(){
            var body = document.body;
            body.classList.add("grayscale");
        },

        reset(){
            this.fontsize = 1;
            this.cont = 0;
            document.documentElement.style.setProperty('--font-size', this.fontsize);

            var body = document.body;
            body.classList.remove("grayscale");
        },

        close(){
            document.getElementById('menu_accesibilidad_dropup').style.setProperty('display','none')
            //menu_accesibilidad_dropup
        }
    }
}
</script>

<style scoped>
.menu-accesibilidad img {
    max-height: 3.2rem !important;
    height: 100px;
}
</style>